<template>
  <div class="custom-tree-container">
    <div class="block">
      <ul class="custom-tree-node-title">
        <li style="width: 80px;">分类ID</li>
        <li>分类名称</li>
        <li style="width: 80px;">分类排序</li>
        <li>图片</li>
        <li>是否屏蔽</li>
<!--        <li>创建时间</li>-->
      </ul>
    </div>
    <div class="tree-background block">
      <el-tree v-loading="loading" :data="categoryList" default-expand-all :expand-on-click-node="false">
        <ul class="custom-tree-node" slot-scope="{ node, data }">
          <li style="width: 80px;">
<!--            <input placeholder="分类ID" v-model="data.cat_id" disabled style="width: 80px;"/>-->
            <span>{{data.cat_id}}</span>
          </li>
          <li>
<!--            <input placeholder="分类名称" v-model="data.cat_name" disabled/>-->
            <span>{{data.cat_name}}</span>
          </li>
          <li style="width: 80px;">
            <input placeholder="分类排序" v-model="data.p_order"  @change="editPOrder(node, data)" style="width: 80px;"/>
          </li>
          <li class="category-icon">
                        <span @click="handleImgChange(data)">
                          <img v-if="data.pic_url" :src="wximageurl + data.pic_url"/>
                          <i v-else class="iconfont icon-image"></i>
                        </span>
          </li>

          <li>
            <el-switch v-model="data.disabled" active-value="true" inactive-value="false" active-color="#13ce66"  inactive-color="#dadadd" @change="switchAuth(node, data)"></el-switch>
          </li>
<!--          <li v-if="data.created_at">{{ data.created_at | datetime }}</li>-->
<!--          <li v-else></li>-->
        </ul>
      </el-tree>
    </div>
    <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg"
               @closeImgDialog="closeImgDialog"></imgPicker>

  </div>
</template>
<script>
import SideBar from '@/components/element/sideBar'
import imgPicker from '@/components/imageselect'
import {getSkuCate, updateSkuCate} from '../../../api/sharer'

export default {
  components: {
    imgPicker, SideBar
  },
  data () {
    return {
      loading: false,
      categoryList: [],
      total_count: 0,
      params: [],
      imgDialog: false,
      isGetImage: true,
      current: ''
    }
  },
  methods: {
    getCategory () {
      this.loading = true
      getSkuCate(this.params).then(response => {
        this.categoryList = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    switchAuth(node, data) {
      let params = {
        'disabled': data.disabled ,
      }
      updateSkuCate(data.id,params).then(res => {
        if (res.data.data) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getCategory()
        }
      })
    },
    editPOrder(node, data) {
      let params = {
        'p_order': data.p_order ,
      }
      updateSkuCate(data.id,params).then(res => {
        if (res.data.data) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getCategory()
        }
      })
    },
    handleImgChange(data) {
      this.imgDialog = true
      this.isGetImage = true
      this.current = data
    },
    pickImg(data) {
      if (!this.current.parent_id || this.current.parent_id == 0) {
        const index = this.categoryList.findIndex(d => d.id === this.current.id);
        this.categoryList[index].pic_url = data.url
      } else if (this.current.parent_id && this.current.level == 1) {
        const findex = this.categoryList.findIndex(d => d.id === this.current.parent_id);
        const cindex = this.categoryList[findex].children.findIndex(d => d.id === this.current.id);
        this.categoryList[findex].children[cindex].pic_url = data.url
      } else {
        let findex
        let cindex
        for (var item in this.categoryList) {
          cindex = this.categoryList[item].children.findIndex(d => d.id === this.current.parent_id);
          findex = item
          if (cindex > -1) break
        }
        const tindex = this.categoryList[findex].children[cindex].children.findIndex(d => d.id === this.current.id);
        this.categoryList[findex].children[cindex].children[tindex].pic_url = data.url

      }
      this.imgDialog = false
    },
    closeImgDialog() {
      this.imgDialog = false
    },
  },

  mounted() {
    this.getCategory()
  }
};
</script>

<style scoped lang="scss">
.custom-tree-container {
  background-color: #fff;
  min-width: 1100px;
}

.tree-background {
  padding-bottom: 45px;
  margin: 0px 20px;
}

.custom-tree-node, .custom-tree-node-title {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  /*padding-right: 8px;*/
  li {
    display: inline-block;
    text-align: center;
    width: 25%;
  }

  li:first-child {
    text-align: left;
  }

  li.category-icon {
    display: flex;
    align-items: middle;
    justify-content: center;

    span {
      height: 30px;
    }

    img {
      width: auto;
      height: 30px;
    }
  }
}

.custom-tree-node-title {
  font-weight: bold;
  color: #909399;
  margin: 0px 20px;

  li {
    padding: 12px 0;
  }
}

.add-category {
  margin-left: 25px;
  margin-top: 30px;

  span {
    cursor: pointer;
  }
}

.remove-category {
  margin-left: 10px;
}

.add-child-category {
  margin-left: 10px;
}
</style>
<style lang="scss">
.custom-tree-container {
  .el-tree-node__content {
    height: 45px;
    padding: 0px;
    line-height: 45px;
  }

  .el-tree > .el-tree-node {
    position: relative;

    &::after {
      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      bottom: 0;
      content: "";
      background-color: #e6e6e6;
    }
  }

  .el-tree > .el-tree-node:first-child {
    &::before {
      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      top: 0;
      content: "";
      background-color: #e6e6e6;
    }
  }
}

.custom-tree-node {
  input {
    border: 1px solid #ddd;
    line-height: 25px;
    padding-left: 5px;
    width: 150px;
  }
}

</style>



// WEBPACK FOOTER //
// sku_cate.vue?7ba5596c